var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-primary",on:{"click":_vm.resetInventory}},[_vm._v(" Resetuj stanje "),_c('md-icon',[_vm._v(" refresh ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }